/**
  * @file
  * Attach behaviors for the join-block component.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Add the join-block content from settings.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.populateJoinBlock = {

    attach: function (context, settings) {
      $('.join-block', context).once('populateJoinBlock').each(function () {
        // Populate the message and share links placeholders.
        $('.join-block .message').html(
          settings.tesla.join_block.message
        );
        $('.join-block .share-links').html(
          settings.tesla.join_block.share_links
        );
        // Fade in the wrapper.
        $('.join-block .wrapper').fadeIn();
      });
    }

  };
})(document, Drupal, jQuery);
